/**
 * GENERATED FILE — do not edit by hand.
 *
 * Source: each tool descriptor's `presentation.statusLabel` and
 * `destructive` flag in apps/api/src/assistant/tools/*\/*.tool.ts.
 * Regenerate with:
 *   pnpm --filter @borradh-workspace/api gen:tool-labels
 *
 * Staleness is enforced in CI by
 * apps/api/src/architecture/tool-labels.spec.ts — a descriptor change
 * without a regen fails the build.
 */
/** Status labels, keyed by canonical tool name. */
export const GENERATED_TOOL_LABELS = {
    appointments_bookAppointment: 'Booking the appointment',
    appointments_cancelAppointment: 'Cancelling',
    appointments_findOpenSlots: 'Finding open slots',
    appointments_listAppointments: 'Listing appointments',
    appointments_markNoShow: 'Marking no-show',
    appointments_rescheduleAppointment: 'Rescheduling',
    appointments_setAppointmentStatus: 'Updating appointment status',
    appointments_summariseUpcomingDay: 'Summarising the day',
    blockedTime_blockCalendar: 'Blocking the calendar',
    campaigns_checkChannels: 'Checking channels',
    campaigns_create: 'Creating campaign',
    campaigns_createSegment: 'Creating audience segment',
    campaigns_launch: 'Launching campaign',
    campaigns_list: 'Listing campaigns',
    campaigns_listWhatsappTemplates: 'Listing WhatsApp templates',
    campaigns_previewAudience: 'Previewing audience',
    campaigns_segments_list: 'Listing audience segments',
    campaigns_setMessage: 'Writing campaign message',
    campaigns_showCampaignPreview: 'Preparing campaign preview',
    chatbots_setDirective: 'Updating chatbot directive',
    chatbots_setEnabled: 'Updating chatbot',
    claire_getAlternativeRecommendation: 'Finding an alternative service',
    claire_publishAd: 'Publishing ad',
    claire_publishOffer: 'Publishing offer',
    claire_recommendOfferForService: 'Picking the offer shape',
    claire_recommendServiceForAds: 'Picking the right service to advertise',
    claire_resolveDisagreement: 'Closing classifier disagreement',
    claire_saveAdDraft: 'Saving draft',
    claire_saveOfferDraft: 'Saving offer draft',
    claire_setPendingAdBudget: 'Noting daily budget',
    claire_setPendingAdCaption: 'Updating ad caption',
    claire_setPendingAdCopy: 'Rewriting ad copy',
    claire_setPendingAdCreative: 'Attaching creative',
    claire_setPendingAdHeadline: 'Updating ad headline',
    claire_setPendingAdPrice: 'Setting intro price on the ad',
    claire_setPendingAdSchedule: 'Noting ad schedule',
    claire_setPendingAdService: 'Pinning the service to advertise',
    claire_setPendingAdTargeting: 'Updating audience targeting',
    claire_setPendingOfferCode: 'Setting offer code',
    claire_setPendingOfferIntroPrice: 'Updating offer pricing',
    claire_setPendingOfferLocations: 'Updating offer locations',
    claire_setPendingOfferName: 'Renaming the offer',
    claire_setPendingOfferRedemptionRules: 'Updating redemption rules',
    claire_setPendingOfferService: 'Pinning the offered service',
    claire_setPendingOfferValidity: 'Setting offer validity',
    claire_showAdPreview: 'Rendering the ad preview',
    claire_showOfferPreview: 'Rendering the offer preview',
    content_combineImages: 'Making the image',
    content_createContent: 'Creating content',
    content_createPremiumVideo: 'Creating your premium ad',
    content_listMedia: 'Looking through the library',
    content_patchContent: 'Making the change',
    content_renderVideo: 'Starting the render',
    context_addServiceLocations: 'Adding branches',
    context_checkConnectedPages: 'Checking connected pages',
    context_createService: 'Creating service',
    context_deleteService: 'Deleting service',
    context_getOrganizationContext: 'Loading the business profile',
    context_getServiceDetails: 'Loading service details',
    context_listOffers: 'Listing offers',
    context_listRecentGraphics: 'Listing recent graphics',
    context_listRecentVideos: 'Listing recent videos',
    context_listServices: 'Listing services',
    context_updateService: 'Updating service',
    customer_conversations_assignConversation: 'Assigning conversation',
    customer_conversations_draftReply: 'Drafting reply',
    customer_conversations_escalateToHuman: 'Escalating to team',
    customer_conversations_listOpenConversations: 'Listing customer conversations',
    customer_conversations_sendReply: 'Sending reply',
    customer_conversations_summariseConversation: 'Reading conversation',
    customer_conversations_summariseConversationsThisWeek: 'Aggregating customer conversations',
    integrations_getChannelStatus: 'Checking channel status',
    integrations_getConnectionHealth: 'Checking connections',
    lead_forms_createLeadForm: 'Checking lead form',
    lead_forms_listLeadForms: 'Listing lead forms',
    lead_forms_previewLeadForm: 'Previewing lead form',
    lead_forms_updateLeadForm: 'Updating lead form',
    leads_createLead: 'Creating lead',
    leads_getLeadStats: 'Reading lead stats',
    leads_listLeads: 'Listing leads',
    leads_searchLeads: 'Searching leads',
    leads_summariseRecentLeads: 'Summarising leads',
    leads_updateLead: 'Updating lead',
    meta_ads_checkMetaIntegration: 'Checking Meta connection',
    meta_ads_confirmLaunchAd: 'Preparing launch confirmation',
    meta_ads_createCampaign: 'Creating campaign',
    meta_ads_createDraftAd: 'Creating draft ad',
    meta_ads_deleteAd: 'Deleting ad',
    meta_ads_deleteCampaign: 'Deleting campaign',
    meta_ads_deleteDraftAd: 'Deleting draft ad',
    meta_ads_diagnoseCampaign: 'Diagnosing campaign',
    meta_ads_duplicateAd: 'Duplicating ad',
    meta_ads_duplicateCampaign: 'Duplicating campaign',
    meta_ads_executeLaunchAd: 'Launching ad',
    meta_ads_generateAdCopy: 'Drafting ad copy',
    meta_ads_getAdInsights: 'Loading ad insights',
    meta_ads_getCampaignInsights: 'Loading campaign insights',
    meta_ads_importAds: 'Importing ads from Meta',
    meta_ads_launchCampaignPackage: 'Preparing campaign package',
    meta_ads_listCampaigns: 'Listing campaigns',
    meta_ads_listLibraryImages: 'Listing library images',
    meta_ads_listRecentAds: 'Listing recent ads',
    meta_ads_pauseAd: 'Pausing ad',
    meta_ads_pauseCampaign: 'Pausing campaign',
    meta_ads_prepareVideoReplacement: 'Preparing video replacement',
    meta_ads_previewCampaign: 'Resolving defaults',
    meta_ads_replaceAdCreative: 'Replacing ad creative',
    meta_ads_resumeAd: 'Resuming ad',
    meta_ads_resumeCampaign: 'Resuming campaign',
    meta_ads_saveChatImages: 'Saving your images to the library',
    meta_ads_suggestAdOptimizations: 'Reviewing ad performance',
    meta_ads_updateAd: 'Updating ad',
    meta_ads_updateBudget: 'Updating budget',
    meta_ads_updateCampaign: 'Updating campaign',
    meta_dispatchTour: 'Starting the tour',
    meta_forgetMemory: 'Forgetting that memory',
    meta_listMemories: 'Checking saved memories',
    meta_loadSkill: 'Switching focus',
    meta_remember: 'Saving that for later',
    meta_setMemoryEnabled: 'Updating a memory',
    offers_createOffer: 'Preparing offer',
    offers_expireOffer: 'Expiring offer',
    offers_extendOffer: 'Extending offer',
    offers_getOfferPerformance: 'Loading offer details',
    offers_publishOffer: 'Publishing offer',
    offers_suggestIntroOffer: 'Shaping the intro offer',
    org_defaults_setOrgDefault: 'Updating defaults',
    organization_updateBookingPolicy: 'Updating the booking policy',
    packages_listSellables: 'Reading the price list',
    practitioners_listTeam: 'Looking up the team',
    reports_summariseBusiness: 'Reading the business report',
    reports_summariseClaire: 'Reading the Claire report',
    sales_getTakings: 'Totalling takings',
    shifts_explainAvailability: 'Checking availability',
    social_posts_createSocialPostDraft: 'Creating post draft',
    social_posts_deleteSocialPostDraft: 'Deleting post draft',
    social_posts_generatePostCaption: 'Generating caption',
    social_posts_listRecentPosts: 'Loading posts',
    social_posts_publishPostNow: 'Publishing post',
    social_posts_schedulePost: 'Scheduling post',
    social_posts_suggestPostingTime: 'Analyzing post timing',
    social_posts_updateSocialPostDraft: 'Updating post draft',
    support_requestSupportChat: 'Bringing in the team',
    videos_autoSelectClips: 'Selecting clips',
    videos_autoSelectMusic: 'Selecting music',
    videos_deleteDraftVideo: 'Deleting video',
    videos_generateTalkingHeadQR: 'Generating QR code',
    videos_generateVideoScript: 'Generating script',
    videos_getVideoStatus: 'Checking video status',
    videos_listDraftClips: 'Reading clip tray',
    videos_useStockClips: 'Importing stock footage',
    website_openDesigner: 'Preparing Claire Designer',
};
/** Every tool gated by the factory approval card (destructive: true). */
export const DESTRUCTIVE_TOOL_NAMES = new Set([
    'appointments_bookAppointment',
    'appointments_cancelAppointment',
    'appointments_markNoShow',
    'appointments_rescheduleAppointment',
    'blockedTime_blockCalendar',
    'campaigns_launch',
    'chatbots_setDirective',
    'chatbots_setEnabled',
    'claire_publishAd',
    'claire_publishOffer',
    'context_addServiceLocations',
    'context_createService',
    'context_deleteService',
    'context_updateService',
    'customer_conversations_assignConversation',
    'customer_conversations_escalateToHuman',
    'customer_conversations_sendReply',
    'leads_createLead',
    'leads_updateLead',
    'meta_ads_deleteAd',
    'meta_ads_deleteCampaign',
    'meta_ads_deleteDraftAd',
    'meta_ads_executeLaunchAd',
    'meta_ads_launchCampaignPackage',
    'meta_ads_pauseAd',
    'meta_ads_pauseCampaign',
    'meta_ads_replaceAdCreative',
    'meta_ads_resumeAd',
    'meta_ads_resumeCampaign',
    'meta_ads_updateAd',
    'meta_ads_updateBudget',
    'meta_ads_updateCampaign',
    'meta_forgetMemory',
    'meta_remember',
    'offers_createOffer',
    'offers_expireOffer',
    'offers_extendOffer',
    'offers_publishOffer',
    'organization_updateBookingPolicy',
    'social_posts_deleteSocialPostDraft',
    'social_posts_publishPostNow',
    'social_posts_schedulePost',
    'videos_deleteDraftVideo',
]);
//# sourceMappingURL=tool-manifest.generated.js.map